import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
// Core components
import Button from 'yoda-core-components/lib/components/Button';
import User from 'yoda-site-components/lib/helpers/User/User';
import map from 'lodash/map';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { bindActionCreators } from 'redux';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import Input from 'yoda-core-components/lib/components/Input/Input';
import * as actions from '../../../actions/MyListAction';
import * as styles from './CreateListDropDown.css';
import { createDropdownMessagesTexts } from '../../../selectors/createDropdownSelector';

const cx = classNames.bind(styles);

const config = {
    regex: {
        listName: /^.{4,24}$/,
    },
    trendingList: {
        key: 'trendinglist',
        value: 'Trending List',
        href: 'trending-list',
        icon: '',
    },
    defaultList: {
        key: 'myFavorites',
        value: 'My Favorites',
        href: '/mylist?id=myFavorites',
    },
};

class CreateListDropDown extends Component {
    static propTypes = {
        myListsDetails: PropTypes.objectOf.isRequired,
        actions: PropTypes.shape({
            createList: PropTypes.func,
        }).isRequired,
        messagesTexts: PropTypes.objectOf.isRequired,
        showTopLevelMessage: PropTypes.func.isRequired,
        openSlider: PropTypes.func.isRequired,
        clickHandler: PropTypes.func.isRequired,
        enableTrendingList: PropTypes.bool,
    };

    static defaultProps = {
        enableTrendingList: false,
    };

    constructor() {
        super();
        this.state = {
            errorMessage: '',
            listName: '',
        };
    }

    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside);
    }

    /* eslint-disable camelcase */
    UNSAFE_componentWillReceiveProps(nextProps) {
        /**
         * Have to move this else where
         */
        const {
            requestFrom = '',
            isSuccess,
            createListError = {},
            createdItem,
        } = nextProps.myListsDetails;
        const { showTopLevelMessage, messagesTexts } = nextProps;
        if (requestFrom === 'POST' && isSuccess) {
            showTopLevelMessage('success', messagesTexts.successMessage);
            setTimeout(() => {
                this.redirectToList(createdItem);
            }, 2000);
        } else if (requestFrom === 'POST' && !isSuccess) {
            showTopLevelMessage('error', createListError.serviceErrorMessage);
            this.setState({ errorMessage: createListError.errorMessage });
        }
    }

    /* istanbul ignore next */
    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    }

    setWrapperRef = (node) => {
        this.wrapperRef = node;
    };

    /* istanbul ignore next */
    handleClickOutside = (event) => {
        /* istanbul ignore if */
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.props.clickHandler();
        }
    };

    redirectToList = (createdItem) => {
        const url = `/mylist?id=${createdItem.id}`;
        window.location.assign(url);
    };

    checkAuth = () => {
        if (!User.isUserLoggedIn()) {
            this.props.openSlider();
            return false;
        }
        return true;
    };

    createListSubmit = (e) => {
        e.preventDefault();
        const {
            messagesTexts,
            actions: { createList },
        } = this.props;
        let errorMessage;
        if (this.checkAuth()) {
            const name = get(e.target, 'addListName.value', '').trim();
            if (!name) {
                errorMessage = messagesTexts.emptyListNameMessage;
            } else if (!config.regex.listName.test(name)) {
                errorMessage = messagesTexts.invalidListNameMessage;
            }
            if (isEmpty(errorMessage)) {
                createList({ name });
            }
        }
        this.setState({ errorMessage });
    };

    createNewListChange = (value) => {
        this.setState({ listName: value, errorMessage: '' });
    };

    renderForm = () => {
        const { messagesTexts } = this.props;
        const { listName, errorMessage } = this.state;
        return (
            <>
                <form onSubmit={this.createListSubmit} noValidate>
                    <fieldset className={dt(['flex', 'flex-col'])}>
                        <div
                            className={`${cx('formGroup')} ${dt([
                                'h-auto',
                                'text-center',
                                'flex',
                                'justify-center',
                            ])}`}
                        >
                            <Input
                                name="addListName"
                                type="text"
                                data-automation-id="input"
                                theme={dt([
                                    'py-3',
                                    'pl-5',
                                    !isEmpty(errorMessage) ? 'border-2' : 'border',
                                    'border-solid',
                                    !isEmpty(errorMessage)
                                        ? '!border-error-border'
                                        : 'border-gray-60',
                                    'border-r-0',
                                    'outline-none',
                                    'rounded-l-lg',
                                    'rounded-r-none',
                                    'disabled:opacity-70',
                                    'text-medium',
                                    'text-black',
                                    'h-12',
                                ])}
                                placeholder="Create New List"
                                value={listName}
                                onChange={this.createNewListChange}
                            />
                            <Button
                                type="submit"
                                automationId="submit-the-list"
                                size="Md"
                                className={`${cx('createSubmitButton')} ${dt([
                                    'min-w-[80px]',
                                    '!rounded-none',
                                    '!rounded-r-lg',
                                    '!w-auto',
                                ])}`}
                            >
                                {messagesTexts.Add}
                            </Button>
                        </div>
                    </fieldset>
                </form>
                {!isEmpty(errorMessage) && (
                    <div data-automation-id="top-message" className={dt(['text-small', 'mt-0.5'])}>
                        <span
                            data-automation-id="message"
                            className={dt([
                                'font-open-sans-regular',
                                'not-italic',
                                'text-error-border',
                                'inline-block',
                                'text-small',
                            ])}
                        >
                            <span>{errorMessage}</span>
                        </span>
                    </div>
                )}
            </>
        );
    };

    render() {
        const { myListsDetails } = this.props;
        const { listItems } = myListsDetails;
        const requestObj = { ...myListsDetails };
        delete requestObj.listItems;
        let listnames = [];
        listnames = map(listItems.listData, (item) => ({
            key: item.id,
            value: item.name,
            href: `/mylist?id=${item.id}`,
        }));
        if (listnames.length === 0) {
            listnames.push(config.defaultList);
        }
        if (this.props.enableTrendingList) {
            listnames.push(config.trendingList);
        }
        const filterOptions = listnames.map((item) => (
            <li
                className={dt(['font-open-sans-regular', 'text-medium', 'text-left', 'mt-4'])}
                key={`${item.key}_${item.value}`}
            >
                <a className={dt(['no-underline', 'text-black'])} href={item.href}>
                    {item.value}
                </a>
            </li>
        ));
        return (
            <div className={cx('createListDropDown')} ref={this.setWrapperRef}>
                <div
                    className={`${cx('tooltip')} ${dt([
                        'absolute',
                        'block',
                        'bg-white',
                        'h-auto',
                        'w-auto',
                        'p-4',
                        'overflow-visible',
                        'rounded',
                        'shadow-elevation1',
                        'border',
                        'border-solid',
                        'border-gray-15',
                        'z-[44]',
                        'top-[38px]',
                        'left-0',
                        'smOnly:max-w-[90vw]',
                        'after:absolute',
                        'after:block',
                        'after:-top-1.5',
                        'after:left-[54px]',
                        'after:h-[14px]',
                        'after:w-[14px]',
                        'after:rotate-45',
                    ])}`}
                >
                    {this.renderForm()}
                    <ul>{filterOptions}</ul>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (store) => ({
    myListsDetails: store.MyList,
    messagesTexts: createDropdownMessagesTexts(store),
    enableTrendingList: store?.context?.featureFlags?.enableTrendingList,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({ ...actions }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateListDropDown);
